import React from "react";
import { DataManRowContext } from "../defines";
import { DataManRowState } from "../types/data";

export interface DataManRowProviderProps extends Pick<DataManRowState, "data"> {
  children: React.ReactNode;
}

export const DataManRowProvider: React.FC<DataManRowProviderProps> = ({
  children,
  data
}) => {
  return (
    <DataManRowContext.Provider value={{ data }}>
      {children}
    </DataManRowContext.Provider>
  );
};
